module.exports = __webpack_public_path__ + "static/logo-dd69d0d87cab4e6f71dce5230afcde58.png";